<template lang="pug">
  overlay(v-bind="$attrs", v-on="$listeners")
    //- body animates separately
    .absolute.inset-0.h-full.overflow-y-scroll.scrolling-touch.overlaymenu__body.scrollbars-hidden(ref="body")
      slot
</template>

<script>
export default {
  name: 'OverlayMenu',
  props: {
    visible: { type: Boolean, default: false }
  },
  watch: {
    visible (vis) {
      if (vis) {
        this.$refs.body.scroll(0, 0)
      }
    }
  }
}
</script>

<style>
</style>
